import { lazy, Suspense, useEffect } from "react";
import { closeFinishes, useFinishesRequest } from "../../lib/finishesRequests";
import { useRender3dRequest } from "../../lib/render3dRequests";
import { useDesign } from "../../lib/store";

const FinishesSheet = lazy(() => import("./FinishesSheet").then((m) => ({ default: m.FinishesSheet })));

/**
 * The Finishes sheet outside the 3D walk-through (Walls chip, Room
 * details). It belongs to the view it was opened from: switching views or
 * opening 3D closes it (`view_change`). Inside 3D the overlay renders its own.
 */
export function FinishesHost() {
  const request = useFinishesRequest();
  const render3d = useRender3dRequest();
  const view = useDesign((s) => s.view);
  const mine = request !== null && !request.in3d;

  useEffect(() => {
    if (!mine) return;
    if (render3d || (request.view !== "render3d" && request.view !== view)) closeFinishes("view_change");
  }, [mine, request, render3d, view]);

  if (!mine || render3d) return null;
  return (
    <Suspense fallback={null}>
      <FinishesSheet key={request.id} request={request} />
    </Suspense>
  );
}
